import * as React from "react";
import { List, Datagrid, ReferenceField, SimpleForm, Filter, Create, ReferenceInput, FunctionField } from 'react-admin';
import { AutocompleteInput } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    sanitizeListRestProps,
    usePermissions
} from 'react-admin';
import { Redirect } from "react-router-dom";

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("users_buildings.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("users_buildings.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
        </TopToolbar>
    );
};

export const UsersBuildingsList = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <List filters={<UsersBuildingsFilter />}{...props} sort={{ field: 'createdAt', order: 'DESC' }} actions={<ListActions />} title="Usuarios y edificios">
            <Datagrid>
                {permissions.includes("users.list") &&
                    <ReferenceField source="userId" label='Usuario' reference="users">
                        <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} link="show" />
                    </ReferenceField>
                }
                {permissions.includes("buildings.list") &&
                    <ReferenceField source="buildingId" label='Edificio' reference="buildings">
                        <FunctionField label="Edificio" render={record => `${record.address}`} link="show" />
                    </ReferenceField>
                }
                <FunctionField label="Fecha" render={(record) => {
                    if (record.createdAt !== null && record.createdAt !== undefined) {
                        return `${record.createdAt.split(" ")[0]}`;
                    } else {
                        return "";
                    }
                }} />
            </Datagrid>
        </List>
    );
}

export const UsersBuildingsCreate = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("users.list") || !permissions.includes("buildings.list")) {
        return <Redirect to="/401" />;
    }

    return (
        <Create {...props}>
            <SimpleForm submitOnEnter={false}>
                {/* <ReferenceInput source="userId" label='Usuario' reference="users" perPage={50}>
                <SelectInput optionText={record => `${record.firstname} ${record.lastname}`}/>
            </ReferenceInput> */}
                {permissions.includes("users.list") &&
                    <ReferenceInput
                        label="Usuario" source="userId" reference="users"
                        allowEmpty
                        sort={{ field: 'firstname', order: 'ASC' }}
                        optionValue="username"
                        suggestionLimit={10}
                        alwaysOn>
                        <AutocompleteInput optionText="filtro" />
                    </ReferenceInput>
                }
                {permissions.includes("buildings.list") &&
                    <ReferenceInput
                        label="Edificio" source="buildingId" reference="buildings"
                        allowEmpty
                        sort={{ field: 'address', order: 'ASC' }}
                        optionValue="address"
                        suggestionLimit={10}
                        alwaysOn>
                        <AutocompleteInput optionText="address" />
                    </ReferenceInput>
                }
            </SimpleForm>
        </Create>
    )
};

const UsersBuildingsFilter = (props) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Filter {...props}>
            {permissions.includes("users.list") &&
                <ReferenceInput
                    label="Usuario" source="userId" reference="users"
                    allowEmpty
                    sort={{ field: 'firstname', order: 'ASC' }}
                    optionValue="username"
                    suggestionLimit={25}
                    alwaysOn>
                    <AutocompleteInput optionText="filtro" />
                </ReferenceInput>
            }
            {permissions.includes("buildings.list") &&
                <ReferenceInput
                    label="Edificio" source="buildingId" reference="buildings"
                    allowEmpty
                    sort={{ field: 'address', order: 'ASC' }}
                    optionValue="address"
                    suggestionLimit={10}
                    alwaysOn>
                    <AutocompleteInput optionText="address" />
                </ReferenceInput>
            }
        </Filter>
    )
};